import { render } from "./RegisterNewPlan.vue?vue&type=template&id=d2652700&scoped=true&ts=true"
import script from "./RegisterNewPlan.vue?vue&type=script&lang=ts"
export * from "./RegisterNewPlan.vue?vue&type=script&lang=ts"

import "./RegisterNewPlan.vue?vue&type=style&index=0&id=d2652700&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2652700"]])

export default __exports__